import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzMenuModule } from 'ng-zorro-antd/menu';

import { AifcFooterComponent } from './footer/aifc-footer.component';
import { AifcHeaderComponent } from './header/aifc-header.component';
import { CookieBannerComponent } from './cookie-banner/cookie-banner.component';

/**
 * Header and footer shared between the public landing and the portal shell,
 * styled after aifc-portal so both properties read as one site.
 */
@NgModule({
  declarations: [AifcHeaderComponent, AifcFooterComponent, CookieBannerComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    NzBadgeModule,
    NzDropDownModule,
    NzIconModule,
    NzMenuModule,
  ],
  exports: [AifcHeaderComponent, AifcFooterComponent, CookieBannerComponent],
})
export class AifcLayoutModule {}
